import type { TenantConfig, TenantId } from './types'
import flexysureConfig from './tenants/flexysure'
import pacisConfig from './tenants/pacis'
import muaConfig from './tenants/mua'
import bayesConfig from './tenants/bayes'

const tenantMap: Record<TenantId, TenantConfig> = {
  flexysure: flexysureConfig,
  pacis: pacisConfig,
  mua: muaConfig,
  bayes: bayesConfig
}

const tenantId = (process.env.REACT_APP_TENANT as TenantId) || 'flexysure'

if (!tenantMap[tenantId]) {
  throw new Error(
    `Unknown tenant "${tenantId}". Valid tenants: ${Object.keys(tenantMap).join(', ')}`
  )
}

const tenantConfig: TenantConfig = tenantMap[tenantId]

export default tenantConfig
export type {
  TenantConfig,
  TenantId,
  TenantSeedTheme,
  TenantTheme,
  TenantDarkTheme,
  TenantColors,
  TenantContent,
  TenantSeo,
  TenantFeature,
  TenantProduct,
  TenantStat,
  PoweredBy
} from './types'
